import { Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
//import MecanicosDB from "../../../Components/JsonData/Operadores.json"
import { useContext, useEffect, useState } from "react";
import api from "../../../Components/Api/Api";
import Spinner from "../../../Components/Spinner";
import { UserContext } from '../../../context/UserContext';

const IniciarMecanica = () => {
    const navigate = useNavigate(); 
    const location = useLocation();
    const {user} = useContext(UserContext)
    const orcamento = location.state;      
    const [mecanicos, setMecanicos] = useState(['']);
    const [mecanico, setMecanico] = useState('');
    const [ShowLoading, setShowLoading] = useState(false) 
    const [cadok, setCadok] = useState(false)
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }    
    interface Itens {
        codigo: string;
        nome: string;
      } 
    const [mecan, setMecan] = useState<Itens[]>([]); 
    const buscamecanicos = () => {  
        api.get('Atendentes?tipo=3',{headers})
        .then(response => {  
            if (response.data.Atendentes.length > 0 ){                      
                if (mecan.length < response.data.Atendentes.length){
                    let p_1 = ['']
                    for (let i = 0; i < response.data.Atendentes.length; i++) {                           
                        p_1.push(response.data.Atendentes[i]['codigo'] + ' ' + response.data.Atendentes[i]['nome']) 
                    } 
                    setMecanicos(p_1) 
                }                                         
            }                                   
        });                
    }    
    useEffect(() => {
        if(mecanicos.length === 1){
            buscamecanicos()
        //     let p_1 = []
        //   for (let i = 0; i <= MecanicosDB.nome.length; i++) {
        //     p_1.push(MecanicosDB.nome[i])
        //   }
        //   setMecanicos(p_1)
      } 
      if(cadok) { 
        navigate('/alinhamento')
        }              
    })
    const chageselectmecanico = (e: any) => {
        if (e.target.value !== '') {
            setMecanico(e.target.value)
        }          
    }   
    const updatemecanico = () => {
        setTimeout(() => {
            if (mecanico !== '' && mecanico !== 'Selecione um operador'){
                setShowLoading(true)
                api.get('iniciaServicos?filial='+user.filial+'&Orcamento='+orcamento+'&Mecanico='+mecanico+'&Status=4',{headers})
                .then(response => {
                      //console.log(response.data['info'])
                      if (response.data['info'].length > 0 ){   
                        if(response.data['info'] === 'iniciado'){
                            setShowLoading(false)
                            alert('Serviço de alinhamento iniciado com sucesso!')
                            setCadok(true) 
                        }  
                        if(response.data['info'] === 'erro'){ 
                            setShowLoading(false)
                            alert('Problema ao inicar ordem de serviço, tente novamente!')               
                        }
                          setShowLoading(false)  
                          //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                      }else{
                        alert('Problema de conexão, tente novamente!')   
                        setShowLoading(false)
                      }                                   
                });
            }else{
                alert("Selecione um Alinhador!")
            }
          }, 10 ); 
    } 
    return (
        <>
        <Container>
            <div>
                <span className="mt-4 d-flex justify-content-center fs-3 text-primary">Iniciar o serviço {orcamento}</span>
            </div>
            <div>
                <label className="me-2">Mecanico:</label>
                <select onChange={(e) => chageselectmecanico(e)}>
                    {mecanicos.map((i: any, k: any) => 
                        <option key={k} value={mecanicos[k]}>{mecanicos[k]}</option> 
                    )}
                </select>                
            </div>
            <div className="mt-4">
                <button className="me-4" onClick={updatemecanico}>Salvar</button>
                <button><Link to='/alinhamento'>Voltar</Link></button>
            </div>
        </Container>
        <Spinner isLoading={ShowLoading} /> 
        </>
    )
}

export default IniciarMecanica;